/**
 * Mapea errores del cliente Better Auth (@better-fetch/fetch) a claves i18n.
 */

const CODE_TO_KEY: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD: "dashboardUi.auth.errors.invalidEmailOrPassword",
  USER_ALREADY_EXISTS: "dashboardUi.auth.errors.userAlreadyExists",
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "dashboardUi.auth.errors.userAlreadyExists",
  PROVIDER_NOT_FOUND: "dashboardUi.auth.errors.providerNotConfigured",
  PASSWORD_TOO_SHORT: "dashboardUi.auth.errors.passwordTooShort",
  PASSWORD_TOO_LONG: "dashboardUi.auth.errors.passwordTooLong",
  INVALID_EMAIL: "dashboardUi.auth.errors.invalidEmail",
  INVALID_TOKEN: "dashboardUi.auth.errors.invalidToken",
  TOKEN_EXPIRED: "dashboardUi.auth.errors.invalidToken",
  RESET_PASSWORD_DISABLED: "dashboardUi.auth.errors.resetDisabled",
  INVALID_ORIGIN: "dashboardUi.auth.errors.invalidOrigin",
  INVALID_CALLBACK_URL: "dashboardUi.auth.errors.invalidOrigin",
  INVALID_REDIRECT_URL: "dashboardUi.auth.errors.invalidOrigin",
  EMAIL_NOT_VERIFIED: "dashboardUi.auth.errors.emailNotVerified",
  INVALID_PASSWORD: "dashboardUi.auth.errors.invalidPassword",
  CREDENTIAL_ACCOUNT_NOT_FOUND: "dashboardUi.auth.errors.credentialAccountNotFound",
};

function readNestedCode(err: unknown): string | undefined {
  if (!err || typeof err !== "object") return undefined;
  const e = err as Record<string, unknown>;
  const inner = e.error;
  if (inner && typeof inner === "object" && "code" in inner && typeof (inner as { code: unknown }).code === "string") {
    return (inner as { code: string }).code;
  }
  if ("code" in e && typeof e.code === "string") return e.code;
  return undefined;
}

export function translateAuthError(err: unknown, t: (key: string) => string): string {
  if (err && typeof err === "object" && "name" in err && (err as { name?: string }).name === "AbortError") {
    return t("dashboardUi.auth.errors.network");
  }
  const code = readNestedCode(err);
  if (code) {
    const key = CODE_TO_KEY[code];
    if (key) return t(key);
  }
  if (err && typeof err === "object" && "message" in err && typeof (err as { message: unknown }).message === "string") {
    const msg = (err as { message: string }).message;
    if (msg.length > 0 && !msg.startsWith("Request failed")) return msg;
  }
  return t("dashboardUi.auth.errors.generic");
}
